<template>
    <div class="filter">
        <nav class="nav">
            <button
                @click="filterTop()"
                class="toggle button button-outline button-icon"
            >
                <i class="fa fa-angle-up"></i>
            </button>
            <span><i class="fa fa-filter"></i> Filters</span>
            <button @click="reset()" class="button button-outline reset">
                Reset
            </button>
        </nav>

        <form action="#" v-on:submit.prevent="filter">
            <div class="filter-date">
                <div class="title"><i class="fa fa-calendar-o"></i> Date</div>
                <div class="dates">
                    <button
                        v-bind:key="key"
                        v-for="(date, key) in datesList"
                        :class="[date.slug, { active: date.active }]"
                        type="button"
                        @click="makeItemActive(date, key, 'dates')"
                    >
                        <span class="day">{{ date.day }}</span>
                        <span class="month">{{ date.month }}</span>
                        <span class="group">{{ date.name }}</span>
                    </button>
                </div>
            </div>

            <div class="filter-location">
                <div class="title">
                    <i class="fa fa-ticket"></i> Tickets Types
                </div>
                <div class="locations">
                    <button
                        v-bind:key="key"
                        v-for="(location, key) in locationsList"
                        :class="[location.slug_en, { active: location.active }]"
                        type="button"
                        @click="makeItemActive(location, key, 'locations')"
                    >
                        <svg-icon class="icon" :name="location.slug_en">
                        </svg-icon>
                        {{ location.name }}
                    </button>
                </div>
            </div>

            <div class="filter-price">
                <div class="title"><i class="fa fa-usd"></i> Tickets Types</div>

                <div class="slider">
                    <vue-slider
                        v-model="filters.price.range"
                        :min="price_range.min"
                        :max="price_range.max"
                        :enable-cross="false"
                        :tooltip-formatter="filters.price.formatter"
                    >
                    </vue-slider>
                </div>
            </div>

            <button type="submit" class="button button-big button-filter">
                Search
            </button>
        </form>
    </div>
</template>

<style lang="scss">
.filter {
    .locations {
        button.active .icon svg path {
            fill: #fff;
        }

        .icon svg {
            width: 100%;
            height: 100%;

            path {
                fill: var(--color-purple-darker);
            }
        }
    }

    .vue-slider .vue-slider-dot {
        &
            + .vue-slider-dot
            .vue-slider-dot-tooltip
            .vue-slider-dot-tooltip-inner,
        .vue-slider-dot-tooltip .vue-slider-dot-tooltip-inner {
            font-size: 1rem;
        }
    }
}
</style>

<style lang="scss" scoped>
.filter {
    padding: 55px 16px 25px;
    position: relative;
    background: #fff;
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);
    border-radius: 15px;
    overflow: hidden;
    margin: 32px auto;
}

.fa {
    color: var(--color-purple-darker);
}

.nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    text-align: center;
    width: 100%;
    font-size: 1.2rem;
    background-color: #fff;
    color: var(--color-purple-darker);
    padding: 10px 16px;
    z-index: 10;
    border-bottom: 1px solid var(--color-gray-light);

    span {
        font-size: 1.6rem;
        color: var(--color-gray-dark-content);
    }
}

.nav.fixed {
    position: fixed;

    .toggle {
        transform: rotate(0deg);
    }
}

.toggle {
    border: 1px solid var(--color-purple-darker);
    height: 34px;
    width: 34px;
    transform: rotate(180deg);
    transition: transform 0.3s ease;

    .fa {
        line-height: 0;
    }

    &:hover .fa {
        color: #fff;
    }
}

.reset {
    background: var(--color-purple-light);
    border-width: 1px;
    height: 34px;
    line-height: 1em;
    font-weight: normal;
    text-transform: uppercase;
    font-size: 0.9rem;
}

.title {
    color: var(--color-gray-medium-content);
    font-size: 1.3rem;
    line-height: 1.3em;
    margin: 20px 0 10px;

    .fa {
        font-size: 0.8em;
    }
}

.dates {
    display: flex;
    justify-content: space-between;
    gap: 4px;
    padding: 0;
    margin: 0;
    list-style: none;

    button {
        border: 1px solid var(--color-gray-light);
        border-radius: 10px;
        -webkit-appearance: none;
        background: #fff;
        width: calc(100% / 5.2);
        padding: 6px 2px 8px;

        &.active {
            .day,
            .month,
            .group {
                color: #fff;
            }

            &.access-group {
                background: linear-gradient(
                    300deg,
                    rgba(185, 6, 109, 1) 0%,
                    rgba(255, 0, 89, 1) 100%
                );
            }

            &.special-group {
                background: linear-gradient(
                    300deg,
                    rgba(54, 170, 192, 1) 0%,
                    rgba(0, 140, 191, 1) 100%
                );
            }

            &.champions-parade {
                background: linear-gradient(
                    300deg,
                    rgba(234, 77, 44, 1) 0%,
                    rgba(255, 166, 46, 1) 100%
                );
            }
        }
    }

    .day,
    .month,
    .group {
        display: block;
        text-transform: uppercase;
        line-height: 1em;
        font-weight: bold;
        color: var(--color-purple-darker);
    }

    .day {
        font-size: 2rem;
    }

    .month {
        font-size: 1.2rem;
    }

    .group {
        line-height: 1.2em;
        font-size: 0.5rem;
        margin-top: 6px;
    }

    @media (min-width: 350px) {
        button {
            padding-left: 4px;
            padding-right: 4px;
        }
    }
}

.locations {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    button {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border: 1px solid var(--color-gray-light);
        border-radius: 10px;
        -webkit-appearance: none;
        background: #fff;
        width: calc(50% - 4px);
        text-align: left;
        padding: 8px 8px 8px 10px;
        line-height: 1.1em;
        height: 56px;
        font-size: 0.8rem;
        font-weight: bold;
        color: var(--color-purple-darker);
        margin-bottom: 10px;

        &.active {
            background: linear-gradient(
                300deg,
                rgba(91, 26, 209, 1) 0%,
                rgba(117, 0, 191, 1) 100%
            );
            color: #fff;
        }
    }

    .icon {
        position: relative;
        width: 35px;
        height: 35px;
        margin-right: 8px;

        &:before {
            content: "";
            position: absolute;
            left: -20%;
            top: -20%;
            width: 100%;
            height: 0;
            padding-top: 0;
            padding-bottom: 100%;
            min-width: 27px;
            background: rgba(var(--color-purple-darker-rgb), 0.1);
            z-index: 0;
            border-radius: 10px;
        }
    }

    @media (min-width: 350px) {
        button {
            font-size: 1rem;
        }
    }
}

.slider {
    padding: 0px 24px 0 18px;
    margin: 16px auto 40px;
}

.button-filter {
    display: block;
    margin: 24px auto 0;
    width: 100%;
    max-width: 300px;
}
</style>

<script>
import VueSlider from "vue-slider-component";
import SvgIcon from "../general/SvgIcon.vue";

export default {
    props: {
        offday: String,
        callback: Function,
        locations: {
            type: Array,
            required: true
        },
        dates: {
            type: Array,
            required: true
        },
        trans: {
            type: Object,
            required: true
        },
        price_range: {
            type: Object,
            required: true
        }
    },

    components: {
        SvgIcon,
        VueSlider
    },

    mounted() {
        this.$nextTick(function() {
            this.applyURLFilteredLocation();
            window.addEventListener("scroll", this.onScroll);
        });
    },

    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll);
    },

    data() {
        return {
            filters: {
                dates: {},
                locations: {},
                price: {
                    range: [this.price_range.min, this.price_range.max],
                    formatter: `${this.trans.tickets.table.currency} {value}`
                }
            },
            datesList: this.dates,
            locationsList: this.locations,
            isScrolledToBottom: false
        };
    },

    methods: {
        applyURLFilteredLocation() {
            for (const index in this.locationsList) {
                const location = this.locationsList[index];

                if (location.active === true) {
                    this.filters.locations[index] = location;
                    this.filter();
                }
            }
        },

        makeItemActive(item, key, name) {
            const status = !item.active;
            item.active = status;

            if (!status && this.filters[name][key] !== undefined) {
                return delete this.filters[name][key];
            }

            return (this.filters[name][key] = item);
        },

        reset() {
            this.filters.dates = [];
            this.filters.locations = [];
            this.filters.price.range = [
                this.price_range.min,
                this.price_range.max
            ];

            this.dates.forEach(date => {
                date.active = false;
            });

            this.locations.forEach(location => {
                location.active = false;
            });

            this.$nextTick(() => {
                this.$el
                    .querySelectorAll(".new-price-value")
                    .forEach((element, index) => {
                        const price = this.filters.price.range[index];
                        element.textContent = price;
                        element.setAttribute("data-price", price);
                    });
            });

            this.filter();
        },

        filter() {
            return this.callback(this.filters);
        },

        onScroll() {
            const nav = this.$el.querySelector(".nav");
            if (window.scrollY > 1000) {
                nav.classList.add("fixed");
                this.isScrolledToBottom = true;
            } else {
                nav.classList.remove("fixed");
                this.isScrolledToBottom = false;
            }
        },

        filterTop() {
            const nav = this.$el.querySelector(".nav");
            if (nav) {
                nav.classList.remove("fixed");
                nav.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    }
};
</script>
